import { Injectable } from '@angular/core';
import { DataEntityExportTemplate } from '@osos/shared/api';
import { DataEntityTemplatePresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class DataEntityTemplateParserV1Service extends ParserBase<
  DataEntityExportTemplate,
  DataEntityTemplatePresenterModel
> {
  constructor() {
    super(DataEntityExportTemplate, DataEntityTemplatePresenterModel, 1);
  }

  getPresenterModel(
    model: DataEntityExportTemplate,
  ): DataEntityTemplatePresenterModel {
    return {
      file: model.file,
      id: model.id,
      level: model.level,
      name: model.name,
      type: model.type,
      exportType: model.exportType,
      additionalProperties: model.additionalProperties,
    } as DataEntityTemplatePresenterModel;
  }
  getDataModel(
    presenter: DataEntityTemplatePresenterModel,
  ): DataEntityExportTemplate {
    return {
      file: presenter.file,
      id: presenter.id,
      level: presenter.level,
      name: presenter.name,
      type: presenter.type,
      exportType: presenter.exportType,
      additionalProperties: presenter.additionalProperties,
    } as DataEntityExportTemplate;
  }
}
